import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class HomecatApi {
    static saveHomecat(home, token ) {          
        let homeEnvio = Object.assign({}, home);
		 
		homeEnvio=JSON.stringify(homeEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/homecat/",
			type: "POST",
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: homeEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}  
    
    static getHomecat(token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/homecat/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static saveImagen(file, token) {  
		return $.ajax({
			url: getLocacion()+"/api/homecat/imagen",
             headers: {"Authorization": "Bearer " + token.idToken},  
            contentType: false,
            processData: false,            
            type: 'POST',
			data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location ='/login';
				}
			}
		});
	}
    
    
    static getImagenes(token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/homecat/imagenes",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    static delteImagen(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/homecat/delete/"+id,
            type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
}